<div
  class="action-ticker-container"
  *ngIf="canShowActionTicker"
  [class.align-button-top]="state === 'expired' || state === 'verified'"
  [ngClass]="backgroundColorClass">
  <div>
    <span
      class="action-ticker-description"
      [class.margin-right]="buttonText !== '' || iconType"
      >{{ description | transloco }}</span
    >
    <ng-container *ngIf="state === 'verified'">
      <span class="action-ticker-additional-description"
        >{{ 'ui-platform.action-ticker.date.verified' | transloco }} {{ verificationValidationDate | date: 'MMMM d, y' }}.</span
      >
      <a
        class="action-ticker-action-link"
        *ngIf="role === 'client'"
        (click)="click(true)"
        >{{ 'ui-platform.action-ticker.action.client.apply' | transloco }}</a
      >
    </ng-container>
    <ng-container *ngIf="state === 'expired'">
      <span class="action-ticker-additional-description"
        >{{ 'ui-platform.action-ticker.date.expired' | transloco }} {{ verificationValidationDate | date: 'MMMM d, y' }}.</span
      >
    </ng-container>
  </div>
  <span *ngIf="!iconType; else iconButton">
    <ui-platform-button
      *ngIf="buttonText !== ''"
      [class.expired-button]=""
      [disabled]="buttonDisabled"
      [label]="buttonText | transloco"
      [type]="buttonType"
      (click)="click(false)"></ui-platform-button>
  </span>
  <ng-template #iconButton>
    <ui-platform-button
      [disabled]="buttonDisabled"
      [icon]="iconType?.type"
      [ngClass]="iconColorClass"
      [type]="'primary'"></ui-platform-button>
  </ng-template>
</div>
